import type { IncomingCall } from 'app/types/incoming-call'

/** CallRail's `source` when source tracking is off for the tracker, not a real source. */
const UNTRACKED_SOURCE = `disabled`

/** The "Google Ads · Atlanta, GA" line, unjoined so callers can append their own parts. */
export function callDetailParts(call: Pick<IncomingCall, 'source' | 'callerCity' | 'callerState'>): string[] {
  const place = [call.callerCity, call.callerState].filter(Boolean).join(`, `)
  const source = call.source === UNTRACKED_SOURCE ? undefined : call.source
  return [source, place].filter((part): part is string => !!part)
}
